import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { TARIFF_TYPES } from '@fttb/common/constants';
import { ymOrderTariffAddressView } from "../analytics";
export var usePhoneInputWithMask = function usePhoneInputWithMask(_ref) {
  var ctn = _ref.ctn,
    errorText = _ref.errorText,
    setCtn = _ref.setCtn,
    tariffType = _ref.tariffType;
  var _useState = useState(ctn || ''),
    _useState2 = _slicedToArray(_useState, 2),
    inputCntWithMask = _useState2[0],
    setInputCntWithMask = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    inputError = _useState4[0],
    setInputError = _useState4[1];
  var validateCtn = function validateCtn() {
    if (ctn.length !== 10) {
      setInputError(errorText);
    }
  };
  var handleChangePhone = function handleChangePhone(_ref2) {
    var value = _ref2.target.value;
    /** PhoneInput api позволяет вводить номер с +0, для корректной валидации "+0" и "+7" убирается регуляркой */
    var parsedPhone = value.replace(/\+[07]|\D/g, '');
    setInputError('');
    if ((parsedPhone === null || parsedPhone === void 0 ? void 0 : parsedPhone.length) === 10 && inputCntWithMask !== parsedPhone) {
      var addressFillText = tariffType === TARIFF_TYPES.presetUp ? 'fmc_address_fill_field' : 'address_fill_field';
      ymOrderTariffAddressView(_defineProperty({}, addressFillText, 'phone'), tariffType);
    }
    setInputCntWithMask(parsedPhone);
    setCtn(parsedPhone);
  };
  return {
    handleChangePhone: handleChangePhone,
    inputCntWithMask: inputCntWithMask,
    inputError: inputError,
    validateCtn: validateCtn
  };
};